import './wdyr'; // <--- first import

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import client from './apolloClient';
import { RecorderProvider } from './contexts/RecorderProvider';
import { VariablesProvider } from './contexts/VariablesProvider';
import { SelectedLeadsProvider } from './contexts/SelectedLeadsProvider';

import Router from './Router';

import './styles/index.css';
import * as serviceWorker from './serviceWorker';
import './fontawesome';


ReactDOM.render(
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <VariablesProvider>
          <SelectedLeadsProvider>
            <RecorderProvider>
              <Router />
            </RecorderProvider>
          </SelectedLeadsProvider>
        </VariablesProvider>
      </ApolloProvider>
    </BrowserRouter>
  </MuiPickersUtilsProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

document.getHTML = function (who, deep) {
  if (!who || !who.tagName) return '';
  let txt;
  let ax;
  let el = document.createElement('div');
  el.appendChild(who.cloneNode(false));
  txt = el.innerHTML;
  if (deep) {
    ax = txt.indexOf('>') + 1;
    txt = txt.substring(0, ax) + who.innerHTML + txt.substring(ax);
  }
  el = null;
  return txt;
};
const f = Element.prototype.removeChild;
Element.prototype.removeChild = function () {
  try {
    return f.apply(this, arguments);
  } catch (e) {
    if (e.message.indexOf('is not a child of this node') >= 0) {
      // The snippets can be as large as the DOM subtree and the list lives in
      // localStorage across sessions, so only a bounded sample is kept: unbounded
      // growth makes every occurrence (and each page load) slower.
      const MAX_ERRORS = 5;
      const MAX_SNIPPET_LENGTH = 2000;
      const removeChildErrors = JSON.parse(localStorage.getItem('removeChildErrors')) || [];
      removeChildErrors.push([
        document.getHTML(this, true).slice(0, MAX_SNIPPET_LENGTH),
        document.getHTML(arguments[0], true).slice(0, MAX_SNIPPET_LENGTH),
      ]);
      localStorage.setItem(
        'removeChildErrors',
        JSON.stringify(removeChildErrors.slice(-MAX_ERRORS)),
      );
    }
    throw e;
  }
};
